/**
 * @generated SignedSource<<8f7527b4658c57fc4ab58bfd545584bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateEmailInput = {
  clientMutationId?: string | null;
  email: string;
};
export type changeEmailDialog_ChangeEmailMutation$variables = {
  input: UpdateEmailInput;
};
export type changeEmailDialog_ChangeEmailMutation$data = {
  readonly InfectopharmAuth: {
    readonly updateEmail: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type changeEmailDialog_ChangeEmailMutation = {
  response: changeEmailDialog_ChangeEmailMutation$data;
  variables: changeEmailDialog_ChangeEmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "InfectopharmAuthMutations",
    "kind": "LinkedField",
    "name": "InfectopharmAuth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "UpdateEmailPayload",
        "kind": "LinkedField",
        "name": "updateEmail",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "changeEmailDialog_ChangeEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "changeEmailDialog_ChangeEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8bace0527814c133106c0b082406c976",
    "id": null,
    "metadata": {},
    "name": "changeEmailDialog_ChangeEmailMutation",
    "operationKind": "mutation",
    "text": "mutation changeEmailDialog_ChangeEmailMutation(\n  $input: UpdateEmailInput!\n) {\n  InfectopharmAuth {\n    updateEmail(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7df6cde1095472152593fda40595b6e9";

export default node;
